module.exports = __webpack_public_path__ + "media/images/front/services/pilot-accdff3fb5bab47a78928d72d6497bad.webp";